<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <div class="d-flex justify-content-end">
                <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                <argon-pagination color="gradient-primary" size="sm">
                  <argon-pagination-item
                  @click="prevPage"
                    prev
                    :disabled="offset === 0 ? true : false" />
                  <argon-pagination-item
                    @click="nextPage"
                    next
                    :disabled="record_more === false ? true : false" />
                </argon-pagination>
              </div>
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="bg-light">
                      <th class="text-uppercase text-xxs font-weight-bolder">Notification</th>
                      <th class="text-uppercase text-xxs font-weight-bolder ps-2">Mark</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="notif in notifications" :key="notif.id">
                      <td>
                        <p><b>{{ notif.subject }}</b><br /><small class="text-muted">{{ notif.created_at }}</small></p>
                        <div v-html="notif.message"/>
                      </td>
                      <td>
                        <a href="#" class="btn btn-sm btn-info" v-if="!notif.is_read" @click="readNotification(notif.id)" :data-button-record-id="notif.id">Mark As Read</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!notifications.length > 0 && !loading"/>
              <loading-state v-if="loading == true"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
//import ArgonBadge from "@/components/ArgonBadge.vue";
// import ArgonInput from "@/components/ArgonInput.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "notifications",
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    EmptyState,
    LoadingState,
    //ArgonBadge
    // ArgonInput
  },
  data() {
    return {
      search: {},
      notifications: [],
      loading: false,
      total_data: 0,
      current_total_data: 0,
      current_page: 0,
      record_more: false,
      offset: 0,
    };
  },
  methods: {
    prevPage() {
      if (this.offset > 0) {
          this.offset = this.offset - 10
          this.getNotifications()
        }
    },
    nextPage() {
      if (this.record_more === true) {
        this.offset = this.offset + 10
        this.getNotifications()
      }
    },
    getNotifications() {
      this.notifications = []
      this.loading = true
      this.total_data = 0
      this.current_total_data = 0
      this.record_more = false
      this.current_page = 0
      this.axios
        .post(
          endpoint.NOTIFICATION_LIST,
          {
            limit: 10,
            offset: this.offset
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            let data = response.data.data;
            this.notifications = data.data;
            this.total_data = data.total_data
            this.current_total_data = data.current_total_data
            this.record_more = data.record_more
            this.current_page = data.current_page
          } else if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: e.response.data.message,
          });
          this.loading = false
        });
    },
    readNotification(notif_id) {
      this.axios
        .post(
          endpoint.MESSAGE_READ,
          {
            message_id: notif_id
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            if (response.data.data) {
              this.$notify({
                type: 'info',
                title: 'Info',
                text: 'Message had read',
              });  
              document.querySelector('[data-button-record-id="' + notif_id +'"]').remove();
            } else {
              this.$notify({
                type: 'error',
                title: 'Error',
                text: 'Can not read message',
              });
            }
          } else {
            if (response.data.response_code !== "4000") {
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: e.response.data.message,
          });
          this.loading = false
        });
    },
    resetOffset(){
      this.offset = 0
    }
  },
  mounted() {
    this.getNotifications();
  }
};
</script>

<style>

</style>